import { isEmpty, isNil } from 'lodash-es';

export const trackEvent = (name: any, value: any) => {
  let sent = false;
  if (
    typeof window !== 'undefined' &&
    !isNil(window?.umami) &&
    !isEmpty(name)
  ) {
    const umami = window.umami;
    try {
      if (value) {
        umami.track(name, value);
      } else {
        umami.track(name);
      }
      sent = true;
    } catch (e) {
      console.error('Cannot track event', name, value, e);
      sent = false;
    }

    if (!sent) {
      console.info('New event: %s -->', name, value);
    }
  } else {
    console.error('Cannot track event', name, value);
  }
};
